import {Helmet} from "react-helmet-async";

const DEFAULT_SITE_URL =
  (process.env.REACT_APP_SITE_URL || "https://stgeorgechicago.org").replace(
    /\/+$/,
    ""
  );
const SITE_NAME = "St. George Coptic Orthodox Church Chicago";
const DEFAULT_IMAGE = `${DEFAULT_SITE_URL}/assets/images/home/St%20George.jpg`;
const DEFAULT_DESCRIPTION =
  "St. George Coptic Orthodox Church in Monee, IL. Liturgies, ministries, sacraments, and resources for our Chicago community.";

export type SeoProps = {
  title?: string;
  description?: string;
  path?: string;
  type?: "website" | "article";
  image?: string;
  noIndex?: boolean;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
};

const buildCanonical = (path?: string) => {
  if (!path) return `${DEFAULT_SITE_URL}/`;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${DEFAULT_SITE_URL}${normalized}`;
};

export function Seo({
  title,
  description,
  path = "/",
  type = "website",
  image,
  noIndex,
  jsonLd,
}: SeoProps) {
  const metaDescription = description || DEFAULT_DESCRIPTION;
  const canonical = buildCanonical(path);
  const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const ogImage =
    image && image.startsWith("http")
      ? image
      : image
      ? `${DEFAULT_SITE_URL}${image.startsWith("/") ? image : `/${image}`}`
      : DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <link rel="canonical" href={canonical} />
      <meta name="description" content={metaDescription} />
      {noIndex && <meta name="robots" content="noindex" />}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}

export const siteUrl = DEFAULT_SITE_URL;
export const siteName = SITE_NAME;
export const defaultDescription = DEFAULT_DESCRIPTION;
export const defaultImage = DEFAULT_IMAGE;
